import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5v15h3","key":"svg-0"}],["path",{"d":"M16 4h3v11m0 4v1h-3","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

/**
 * IconBracketsOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhY2tldHMtb2ZmIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDV2MTVoMyIgLz4KICA8cGF0aCBkPSJNMTYgNGgzdjExbTAgNHYxaC0zIiAvPgogIDxwYXRoIGQ9Ik0zIDNsMTggMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brackets-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBracketsOff = createReactComponent('outline', 'brackets-off', 'BracketsOff', __iconNode);

export default IconBracketsOff;